module.exports = __webpack_public_path__ + "static/system-CRM-blog-a0e5598879300a494c775a3ca8fb62a1.png";